import React from "react";
import { PAYMENT_METHODS, VALIDITY_OPTIONS } from "../../Helper/Cotizacion/quoteModel";

const PaymentConditionsForm = ({ quote, onChange }) => {
	const handleField = (event) => {
		const { name, value } = event.target;
		onChange({ [name]: value });
	};

	const handleValidity = (event) => {
		const value = event.target.value;
		if (value === "custom") {
			onChange({ validityDays: "custom" });
		} else {
			onChange({ validityDays: Number(value), customValidityDays: "" });
		}
	};

	const validitySelectValue =
		quote.validityDays === "custom" ? "custom" : String(quote.validityDays || 15);

	return (
		<section style={{ marginBottom: "24px" }}>
			<h5 style={{ marginBottom: "8px" }}>5. Forma de pago y condiciones</h5>
			<div className="grid-x grid-margin-x">
				<div className="cell small-12 medium-6">
					<label>
						Forma de pago <span style={{ color: "#c53030" }}>*</span>
						<select
							name="paymentMethod"
							value={quote.paymentMethod}
							onChange={handleField}
						>
							<option value="">Seleccionar</option>
							{PAYMENT_METHODS.map((method) => (
								<option key={method} value={method}>
									{method}
								</option>
							))}
						</select>
					</label>
					{quote.paymentMethod === "Otra" ? (
						<label>
							Especificar forma de pago
							<input
								type="text"
								name="customPaymentMethod"
								value={quote.customPaymentMethod}
								onChange={handleField}
							/>
						</label>
					) : null}
				</div>
				<div className="cell small-12 medium-3">
					<label>
						Vigencia
						<select value={validitySelectValue} onChange={handleValidity}>
							{VALIDITY_OPTIONS.map((option) => (
								<option key={option.label} value={String(option.value)}>
									{option.label}
								</option>
							))}
						</select>
					</label>
					{quote.validityDays === "custom" ? (
						<label>
							Días personalizados
							<input
								type="number"
								min="1"
								name="customValidityDays"
								value={quote.customValidityDays}
								onChange={handleField}
							/>
						</label>
					) : null}
				</div>
				<div className="cell small-12 medium-3">
					<label>
						Plazo de ejecución
						<input
							type="text"
							name="executionTime"
							value={quote.executionTime}
							onChange={handleField}
						/>
					</label>
				</div>
				<div className="cell small-12 medium-6">
					<label>
						Condiciones comerciales
						<textarea
							name="conditions"
							rows={3}
							value={quote.conditions}
							onChange={handleField}
						/>
					</label>
				</div>
				<div className="cell small-12 medium-6">
					<label>
						Observaciones
						<textarea name="notes" rows={3} value={quote.notes} onChange={handleField} />
					</label>
				</div>
			</div>
		</section>
	);
};

export default PaymentConditionsForm;
